import { Action, createReducer, on } from '@ngrx/store';
import { commonPersonActions } from './person.action';
import { CommonPersonState, commonPersonIS } from './person.state';

const commonPersonRegister = createReducer(
  commonPersonIS,
  on(commonPersonActions.setResultAction, (state, result) => ({
    ...state,
    result,
  })),

  on(commonPersonActions.addResultAction, (state, person) => ({
    ...state,
    result: {
      ...state.result,
      content: [person, ...state.result.content],
      numberOfElements: state.result.numberOfElements + 1,
      totalElements: state.result.totalElements + 1,
    },
  })),

  on(commonPersonActions.patchResultAction, (state, person) => ({
    ...state,
    result: {
      ...state.result,
      content: state.result.content.map((item) => {
        if (item.id === person.id) {
          return person;
        }
        return item;
      }),
    },
  })),

  on(commonPersonActions.setPersonAction, (state, data) => ({
    ...state,
    data,
  })),

  on(commonPersonActions.setLocationBornAction, (state, locationBorn) => ({
    ...state,
    locationBorn,
  })),

  on(commonPersonActions.setPersonDefaultAction, (state) => ({
    ...state,
    data: commonPersonIS.data,
    locationBorn: commonPersonIS.locationBorn,
  })),

  on(commonPersonActions.setAllDefaultAction, () => commonPersonIS)
);

export function commonPersonReducer(
  state: CommonPersonState,
  action: Action
): any {
  return commonPersonRegister(state, action);
}
